// Render user-authored markdown to HTML for display. Messages come from
// potentially hostile peers, so raw HTML is disabled in the parser and the
// output is sanitized with DOMPurify before it ever touches the DOM.
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

const md = new MarkdownIt({
  html: false, // never interpret raw HTML embedded in a peer's message
  linkify: true,
  breaks: true,
});

export function renderMarkdown(markdown: string): string {
  const dirty = md.render(markdown ?? "");
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } });
}
